<template>
<div class="flex">
    <router-link
      :props="report.props"
      :to="{ path: report.path }"
      class="flex items-center w-full gap-2 px-4 py-2 mr-2 bg-white hover:shadow-md"
    >
      <font-awesome-icon :icon="['far', icon]" />
      <div class="ml-2">{{ report.text }}</div>
    </router-link>
</div>
</template>

<script>
  export default {
    name: "ReportLink",
    props: {
      report: {
        type: Object,
        default: () => {}
      },
    },
    computed: {
      icon () {
        return this.report.icon != null ? this.report.icon : 'table'
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>